// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAWVZadmiXx6h5MVXPUQwb7ZWC8NDbrrSk",
  authDomain: "auth.scan360.in",
  projectId: "scan360-4142b",
  storageBucket: "scan360-4142b.firebasestorage.app",
  messagingSenderId: "32699119561",
  appId: "1:32699119561:web:0ca56d9a6da8913b099a18",
  measurementId: "G-97V6GKBCT4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
